// /* logo animation delay  */
// window.addEventListener("load", function () {
//   setTimeout(function () {
//     document.getElementById("logo").classList.add("background", "removestroke");
//   }, 1800);
// });

// /* logo  delay reload */
// document.addEventListener("DOMContentLoaded", function () {
//   setTimeout(function () {
//     document.querySelector(".header-logo-glowbus").style.display = "block";
//   }, 0); // 1 second
// });


// window.addEventListener('load', function() {
//   setTimeout(function() {
//     const logoElement = document.querySelector('.cs-main-logo');
    
//     // Ensure the element exists before adding classes
//     if (logoElement) {
//       // Add the vanish class first
//       logoElement.classList.add('vanish');
      
//       // Check if vanish class is added
//       console.log('Vanish class added:', logoElement.classList.contains('vanish'));
      
//       // After a longer delay, add the main-logo-content class without removing vanish
//       setTimeout(function() {
//         logoElement.classList.add('main-logo-content');
        
//         // Check if main-logo-content is added
//         console.log('Main-logo-content class added:', logoElement.classList.contains('main-logo-content'));
//       }, 500); // Increased delay before adding main-logo-content
//     } else {
//       console.log('Element .cs-main-logo not found');
//     }
//   }, 10); // Initial delay before starting the process
// });


	
$(document).ready(function(e) {
    var $svg = $('#toplogo').drawsvg({
        callback: function() {
            // Ensure the logo animation is fully done before adding the background class
            setTimeout(function() {
                $('.logo').addClass('background'); // Add the background class after animation
            }, 500); // Adjusted to ensure it's after animation time

            setTimeout(function() {
                $('.logo').addClass('removestroke'); // Remove stroke after the background is added
            }, 700); // Adjusted for smooth timing

        }
    });

    // Start the SVG animation
    $svg.drawsvg('animate');
});

	